import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { map, takeUntil } from 'rxjs/operators';
import {
	CommunicationEvents,
	SubscriptionCategory,
	SubscriptionChoosePlan,
	SubscriptionPlan,
	SubscriptionPlanResponse
} from '../../subscription.model';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';
import { IframeService } from '@services/helpers/iframe-service/iframe.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountServiceProvider } from '@services/user/account.service';

@Component({
	selector: 'subscription-modal',
	template: require('./subscription-modal.html'),
	styles: [require('./subscription-modal.scss')]
})
export class SubscriptionModalComponent implements OnInit {
	@Input() urlToLoad: string;

	categories: SubscriptionCategory;
	categoriesLength: number;
	selectedCategory: Array<SubscriptionPlan> = [];
	categoriesNames: Array<string> = [];
	modalTitle: string;
	priceExplanation: string;
	showModalContent: boolean;

	private iframeOpenEvent;
	private iframeCloseEvent;
	private unsubscribe: Subject<any> = new Subject();

	constructor(
		private subscriptionService: NewSubscriptionServiceDataProvider,
		private renderer: Renderer2,
		private iframeService: IframeService,
		private activeModal: NgbActiveModal,
		private accountService: AccountServiceProvider
	) {}

	ngOnInit(): void {
		this.fetchSubscriptionPlans();
		this.onCheckoutPlanModalIframeOpen();
		this.onCheckoutPlanModalIframeClose();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	closeModal(): void {
		this.subscriptionService.setChoosePlanOpenModalStatus({
			state: false,
			payload: null
		});
		this.activeModal.dismiss();
	}

	changeSelectedCategory(category: string): void {
		this.changeActiveCategory(category);
	}

	selectPlan(plan: SubscriptionPlan): void {
		this.iframeService.setUrlIframe(plan.actions.SELECT_PLAN.url);
	}

	private changeActiveCategory(category: string): void {
		this.selectedCategory = this.categories[category];
	}

	private fetchSubscriptionPlans(): void {
		this.subscriptionService
			.getSubscriptions(this.urlToLoad)
			.pipe(
				takeUntil(this.unsubscribe),
				map(
					(data: SubscriptionPlanResponse): SubscriptionChoosePlan => data.data
				)
			)
			.subscribe((data: SubscriptionChoosePlan): void =>
				this.successGetSubscriptionPlans(data)
			);
	}

	private successGetSubscriptionPlans(data: SubscriptionChoosePlan): void {
		const categories = Object.keys(data.category);

		this.categories = data.category;
		this.categoriesLength = categories.length;
		this.selectedCategory = this.categories[Object.keys(this.categories)[0]];
		this.categoriesNames = categories;
		this.modalTitle = data.title;
		this.priceExplanation = data.priceComment;
		this.showModal();
	}

	private showModal(): void {
		this.showModalContent = true;
	}

	private unsubscribeIframeEvents(): void {
		this.iframeOpenEvent();
		this.iframeCloseEvent();
	}

	private onCheckoutPlanModalIframeOpen(): void {
		this.iframeOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.planCheckoutOpen,
			(): void => {}
		);
	}

	private onCheckoutPlanModalIframeClose(): void {
		this.iframeCloseEvent = this.renderer.listen(
			'document',
			CommunicationEvents.planCheckoutClose,
			(): void => {
				this.unsubscribeIframeEvents();
				this.iframeService.setUrlIframe(null);
			}
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/subscription/modals/subscription-modal/subscription-modal.ts